import React from 'react';

const ComprasProjectFilterSelect = ({
  value = 'all',
  onChange,
  projects = [],
  className = 'border border-gray-300 rounded-lg px-3 py-2 min-w-[180px]',
  includeAllOption = true,
  includeNoneOption = true,
}) => (
  <select value={value} onChange={onChange} className={className}>
    {includeAllOption && <option value="all">Todos los proyectos</option>}
    {includeNoneOption && <option value="none">Sin proyecto</option>}
    {projects.map((project) => (
      <option key={project.id} value={project.id}>
        {project.code ? `${project.code} - ${project.name}` : project.name}
      </option>
    ))}
  </select>
);

export default ComprasProjectFilterSelect;
